import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { themeVars } from 'src/ui-components/theme/theme';

export const MenuItem = styled.div<{
  $isActive?: boolean;
  $isCollapsed: boolean;
  $isChild?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-weight: 400;
  font-family: ${themeVars.fonts.telka};
  color: #504c55;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  line-height: 20px;
  padding: ${({ $isChild }) => ($isChild ? '8px 8px 8px 16px' : '14px 8px 14px 16px')};
  border-radius: 48px;
  cursor: pointer;

  &:hover {
    text-decoration: none;
    color: #504c55;
    background: ${themeVars.colors.titan200};
  }

  ${({ $isActive }) =>
    $isActive &&
    css`
      font-weight: 500;
      background: #84344e !important;
      color: ${themeVars.colors.titan25} !important;
      font-family: ${themeVars.fonts.telkaExtended};
    `}

  ${({ $isCollapsed }) =>
    $isCollapsed &&
    css`
      padding: 8px;
      border-radius: 50%;
      width: fit-content;
    `}
`;

export const NavTitle = styled.span`
  flex: 1;
  cursor: pointer;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  padding-right: 8px;
`;

export const FrontMenuPopupWrapperItem = styled.div<{ $dangerous?: boolean; $isActive?: boolean }>`
  color: #121517;
  border-radius: 8px;
  background: #fff;
  width: 100%;
  padding: 0 12px;
  min-height: 32px;
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 1px solid #fff;

  ${({ $dangerous }) =>
    $dangerous &&
    css`
      color: #84344e;
      font-weight: 500;
    `}
  ${({ $isActive }) =>
    $isActive &&
    css`
      font-weight: 500;
      background: #e1e3da !important;
      border: 1px solid #e1e3da;
    `}
    &:hover {
    border: 1px solid #e1e3da;
    background: #eeefe9;
  }
`;

export const MenuIcon = styled.div<{ $src: string; $isActive?: boolean }>`
  width: 16px;
  height: 16px;
  mask: url(${({ $src }) => $src}) no-repeat center / contain;
  background-color: ${({ $isActive }) => ($isActive ? themeVars.colors.titan25 : '#504c55')};
`;
